var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"back",on:{"click":_vm.navigateBack}},[_c('img',{staticClass:"back__arrow",attrs:{"src":require("@/assets/img/main/arrow_back.png"),"alt":"arrow back"}}),_vm._v(" "),_c('span',[_vm._v("Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }